<ng-container *ngIf="data?.title">
  <p class="title">{{ data.title }}</p>
</ng-container>

<p>
  {{ data.content || '' }}
  <span class="note" *ngIf="data?.note"><br />{{ data.note || '' }}</span>
</p>

<div class="button-box">
  <button mat-flat-button (click)="close()" class="cancel-button">{{ data.cancelActionContent || '取消' }}</button>
  <!-- 使用自定義顏色的確認按鈕 -->
  <button
    *ngIf="data.confirmButtonColor"
    mat-flat-button
    (click)="nextAction()"
    [style.background-color]="data.confirmButtonColor"
    [style.color]="data.confirmButtonTextColor">
    {{ data.nextActionContent || '確認' }}
  </button>

  <!-- 使用預設 Material Design 主題的確認按鈕 -->
  <button
    *ngIf="!data.confirmButtonColor"
    mat-flat-button
    color="primary"
    class="download-button"
    (click)="nextAction()">
    {{ data.nextActionContent || '確認' }}
  </button>
</div>
